// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__bByIH","truncatedText":"styles_truncatedText__bzWPK","fullText":"styles_fullText__tqKnu","textContainer":"styles_textContainer__QpLnb"};